module.exports = __webpack_public_path__ + "img/imagen.488bac0b.png";